module.exports = __webpack_public_path__ + "img/zuaoCtCm.da663c60.svg";